module.exports = __webpack_public_path__ + "static/media/facundo-ruiz-rERuRyBjzgU-unsplash.a65a52f2.jpg";